import { render, staticRenderFns } from "./enterpriseDetail.vue?vue&type=template&id=23e52e2c&scoped=true"
import script from "./enterpriseDetail.vue?vue&type=script&lang=js"
export * from "./enterpriseDetail.vue?vue&type=script&lang=js"
import style0 from "./enterpriseDetail.vue?vue&type=style&index=0&id=23e52e2c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e52e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e52e2c')) {
      api.createRecord('23e52e2c', component.options)
    } else {
      api.reload('23e52e2c', component.options)
    }
    module.hot.accept("./enterpriseDetail.vue?vue&type=template&id=23e52e2c&scoped=true", function () {
      api.rerender('23e52e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/enterpriseDetail.vue"
export default component.exports